<ng-container>
    <router-outlet></router-outlet>
    <p-toast position="bottom-right"></p-toast>
    <app-modal-container></app-modal-container>
    <p-confirmDialog></p-confirmDialog>
</ng-container>
